const SIGN_FLOW_TYPES = {
  SignOnly: 1,
  ModalInputThenSign: 2,
  WebFormThenSign: 3,
};

export default SIGN_FLOW_TYPES;
